// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageAdminUser .text-right {\n  text-align: right; }\n\n.PageAdminUser .text-fixed {\n  font-family: monospace; }\n\n.PageAdminUser .text-center {\n  text-align: center; }\n", ""]);
// Exports
module.exports = exports;
